import React, { Component } from "react";
import Select from 'react-select';
// Usar react-date-range (compatible con React 17)
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import 'moment/locale/es';
import '../styles/datepicker-override.css';
import '../styles/pagination-override.css';
import ReactPaginate from 'react-paginate';
import { LangContext } from "../LangContext.jsx";
moment.locale('es');
class ReportsProviders extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            providers: [],
            currentPage: 0,
            itemsPerPage: 10,
            totalPages: 0,
            showFrom: 0,
            showTo: 0,
            totalProviders: 0,
            showExport: true,
            showRut: false,
            selectedDossierType: null,
            selectedId: null,
            selectedName: null,
            selectedFiscalName: null,
            selectedRfc: null,
            selectedPersonType: null,
            selectedEmail: null,
            selectedActive: null,
            selectedHasClient: null,
            selectedHasProvider: null,
            selectedHasCustomer: null,
            selectedTotalDossiers: null,
            selectedCountryId: null,
            selectedZipCode: null,
            selectedMunicipio: null,
            dossierTypeOptions: [
                {value: "Interno", label: "Interno"},
                {value: "Normal", label: "Normal"},
            ],
            idOptions: [],
            nameOptions: [],
            fiscalNameOptions: [],
            rfcOptions: [],
            personTypeOptions: [
                {value: "Física", label: "Física"},
                {value: "Jurídica", label: "Jurídica"},
                {value: "Moral", label: "Moral"},
                {value: "Natural", label: "Natural"},
            ],
            emailOptions: [],
            activeOptions: [
                {value: "Si", label: "Si"},
                {value: "No", label: "No"}
            ],
            hasClientOptions: [
                {value: "Si", label: "Si"},
                {value: "No", label: "No"}
            ],
            hasProviderOptions: [
                {value: "Si", label: "Si"},
                {value: "No", label: "No"}
            ],
            hasCustomerOptions: [
                {value: "Si", label: "Si"},
                {value: "No", label: "No"}
            ],
            hasOwnOptions: [
                {value: "Si", label: "Si"},
                {value: "No", label: "No"}
            ],
            totalDossiersOptions: [],
            countryIdOptions: [
                {value: "2", label: "Colombia"},
                {value: "1", label: "México"}
            ],
            zipCodeOptions: [],
            municipioOptions: [],
            showAdvancedFilters: false,
            focusedInput: null,
            startDate: null,
            endDate: null,
            showCreatedPicker: false,
            params : {
                provider:{
                    tipo_expediente: null,
                    id: null,
                    name: null,
                    fiscal_name: null,
                    rfc: null,
                    person_type: null,
                    email: null,
                    active: null,
                    HasClient: null,
                    HasProvider: null,
                    HasCustomer: null,
                    HasOwn: null,
                    total_dossiers: null,
                    country_id: null,
                    zipcode: null,
                    municipio: null,
                    created_at: null,
                },
                sort:{
                    order: null,
                    column: null
                },
                page: 0,
                limit:  10,
            },
        };
        this.createdPickerRef = React.createRef();
    } 

    getProviders(isExport = false){
        const { currentPage, itemsPerPage } = this.state;
        axios.get('/api/reports/providers', {
                params: {
                    ...this.state.params,
                    page: currentPage +1,
                    limit: itemsPerPage,
                    exportFiles: isExport
                }
            }).then(res=>{
                const providers = res.data.data;
                if  (isExport){
                    let title;
                    let html;  
                        title = 'Generacion de reporte de invitados en proceso';
                        html = 'Tu solicitud de reporte de invitados está en proceso.<br> En breve te compartiremos la liga al correo electrónico registrado.'
                        if(res.data.in_process == true){
                            Swal.fire({
                                title: title,
                                html: 'Tienes un reporte en proceso, intentalo de nuevo mas tarde',
                                icon: 'info',
                                confirmButtonText: 'Aceptar',
                                buttonsStyling: false, 
                                customClass: {
                                    confirmButton: "btn font-weight-bold btn-primary"
                                }
                                });
                        }else
                        {
                            Swal.fire({
                                title: title,
                                html: html,
                                icon: 'info',
                                confirmButtonText: 'Aceptar',
                                buttonsStyling: false, 
                                customClass: {
                                    confirmButton: "btn font-weight-bold btn-primary"
                                }
                                });
                        }    
                        }else{
                    this.setState({
                        providers,
                        showFrom: res.data.from,
                        showTo: res.data.to,
                        totalProviders: res.data.total,
                    totalPages: Math.ceil(res.data.total / itemsPerPage)
                });
                }
        })
        this.getFilters();
    }

    getFilters() {
        axios.get('/api/filters/providers', {
            params: {
                ...this.state.params,
            }
        }).then((res) => {
            const providerFilters = res.data;

            this.setState({
                idOptions: providerFilters.idOptions,
                nameOptions: providerFilters.nameOptions,
                fiscalNameOptions: providerFilters.fiscalNameOptions,
                rfcOptions: providerFilters.rfcOptions,
                emailOptions: providerFilters.emailOptions,
                totalDossiersOptions: providerFilters.totalDossiersOptions,
                zipCodeOptions: providerFilters.zipCodeOptions,
                municipioOptions: providerFilters.municipioOptions,
            });
        });
    }

    exportReports() {
        this.getProviders(true);
        return;  
    }

    componentDidMount() {
        this.getProviders(false);
        document.addEventListener('mousedown', this.handleClickOutside);
    };

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleDossierTypeChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                tipo_expediente: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedDossierType: event,
        }, () => this.getProviders(false));
    }

    handleIdChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                id: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedId: event,
        }, () => this.getProviders(false));
    }

    handleNameChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                name: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedName: event,
        }, () => this.getProviders(false));
    }

    handleFiscalNameChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                fiscal_name: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedFiscalName: event,
        }, () => this.getProviders(false));
    }

    handleRfcChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                rfc: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRfc: event,
        }, () => this.getProviders(false));
    }

    handlePersonTypeChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                person_type: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedPersonType: event,
        }, () => this.getProviders(false));
    }

    handleEmailChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                email: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedEmail: event,
        }, () => this.getProviders(false));
    }

    handleActiveChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                active: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedActive: event,
        }, () => this.getProviders(false));
    }

    handleHasClientChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                HasClient: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedHasClient: event,
        }, () => this.getProviders(false));
    }

    handleHasProviderChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                HasProvider: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedHasProvider: event,
        }, () => this.getProviders(false));
    }

    handleHasCustomerChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                HasCustomer: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedHasCustomer: event,
        }, () => this.getProviders(false));
    }
    handleHasOwnChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                HasOwn: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedHasOwn: event,
        }, () => this.getProviders(false));
    }

 

    handletotalDossiersChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                total_dossiers: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedTotalDossiers: event,
        }, () => this.getProviders(false));
    }

    handleCountryIdChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                country_id: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedCountryId: event,
        }, () => this.getProviders(false));
    }

    handleZipCodeChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                zipcode: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedZipCode: event,
        }, () => this.getProviders(false));
    }

    handleMunicipioChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                municipio: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedMunicipio: event,
        }, () => this.getProviders(false));
    }

    handleDateChange = (ranges) => {
        const sel = ranges.selection || {};
        const startDate = sel.startDate || null;
        const endDate = sel.endDate || null;
        const startStr = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endStr = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                created_at: { startDate: startStr, endDate: endStr }
            }
        };

        this.resetCurrentPage();
        this.setState({
            startDate: startStr,
            endDate: endStr,
            params: updatedParams
        }, () => this.getProviders(false));
    }

    toggleCreatedPicker = () => this.setState(prev => ({ showCreatedPicker: !prev.showCreatedPicker }));
    handleClickOutside = (e) => {
        if (this.state.showCreatedPicker && this.createdPickerRef.current && !this.createdPickerRef.current.contains(e.target)) {
            this.setState({ showCreatedPicker: false });
        }
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        this.setState({ currentPage: selected }, () => this.getProviders(false));
    }

    handleItemsPerPageChange = (event) => {
        const newItemsPerPage = parseInt(event.target.value, 10);
        this.setState({
            itemsPerPage: newItemsPerPage,
            currentPage: 0
        }, () => this.getProviders(false));
    };

    resetCurrentPage = () => {
        this.setState({
            currentPage: 0,
        });
    }

    clearDates = () => {
        const updatedParams = {
            ...this.state.params,
            provider: {
                ...this.state.params.provider,
                created_at: {startDate: null, endDate: null}
            }
        };

        this.setState({
            params: updatedParams,
            startDate: null,
            endDate: null
        }, () => this.getProviders(false));
    }

    clearFilters = () => {
        this.setState({
            selectedDossierType: null,
            selectedId: null,
            selectedName: null,
            selectedFiscalName: null,
            selectedRfc: null,
            selectedPersonType: null,
            selectedEmail: null,
            selectedActive: null,
            selectedHasClient: null,
            selectedHasProvider: null,
            selectedHasCustomer: null,
            selectedHasOwn: null,
            selectedTotalDossiers: null,
            selectedCountryId: null,
            selectedZipCode: null,
            selectedMunicipio: null,
            startDate: null,
            endDate: null,
            params : {
                provider:{
                    tipo_expediente: null,
                    id: null,
                    name: null,
                    fiscal_name: null,
                    rfc: null,
                    person_type: null,
                    email: null,
                    active: null,
                    HasClient: null,
                    HasProvider: null,
                    HasCustomer: null,
                    HasOwn: null,
                    total_dossiers: null,
                    country_id: null,
                    zipcode: null,
                    municipio: null,
                    created_at: null,
                },
                sort:{
                    order: null,
                    column: null
                },
            },
        }, this.getProviders);
    };

    handleSort = (column) => {
        this.setState(prevState => {
            if (column === prevState.params.sort.column) {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: prevState.params.sort.order === 'asc' ? 'desc' : 'asc'
                        }
                    }
                };
            } else {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: 'asc'
                        }
                    }
                };
            }
        }, this.getProviders);
    };

    toggleAdvancedFilters = () => {
        this.setState(prevState => ({
            showAdvancedFilters: !prevState.showAdvancedFilters
        }));
    };

    render() {
        const { lang } = this.context; 
      return (
        <>
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div>
                        <h5 className="text-dark font-weight-bold my-1 mr-5">
                            {lang.get('messages.reporte_de_invitados')}
                        </h5>
                        <p className="text-dark-50 font-weight-bold my-1 mr-5">
                            <span className="text-primary datatable-count">{this.state.totalProviders}</span> {lang.get('messages.invitados_registrados')}.
                        </p>
                    </div>
                    <div className="d-flex align-items-center flex-wrap">
                        {this.state.showExport &&
                            <a
                                id="export"
                                className="btn btn-primary px-10 font-weight-bolder"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.exportReports();
                                }}
                                >{lang.get('messages.exportar')}</a>
                        }
                    </div>
                </div>
            </div>
            
            <div className="container">
                <div className="datatable-filters">
                    <div className="d-flex justify-content-between mb-4">
                        <div className="font-weight-bolder">{lang.get('messages.filtrar_por')}:</div>
                        <a
                            className="datatable-clear-filters float-right text-primary"
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.clearFilters();
                            }}
                        ><strong>{lang.get('messages.limpiar_todos_los_filtros')}</strong></a>
                    </div>

                    <div className="d-flex justify-content-between mb-4 default">
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.tipo_de_expediente')}</label>
                            <Select
                                value={this.state.selectedDossierType}
                                onChange={this.handleDossierTypeChange}
                                options={this.state.dossierTypeOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_tipo_de_expediente')}</div>}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">Id</label>
                            <Select
                                value={this.state.selectedId}
                                onChange={this.handleIdChange}
                                options={this.state.idOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_id')}</div>}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">Nombre</label>
                            <Select
                                value={this.state.selectedName}
                                onChange={this.handleNameChange}
                                options={this.state.nameOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_nombre')}</div>}
                                isClearable={true}
                            />
                        </div>
                    </div>
                    {this.state.showAdvancedFilters && (
                        <div className="advanced-filters">
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.razon_social')}</label>
                                    <Select
                                        value={this.state.selectedFiscalName}
                                        onChange={this.handleFiscalNameChange}
                                        options={this.state.fiscalNameOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_razon_social')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">Identidad fiscal</label>
                                    <Select
                                        value={this.state.selectedRfc}
                                        onChange={this.handleRfcChange}
                                        options={this.state.rfcOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_rfc')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.tipo_persona')}</label>
                                    <Select
                                        value={this.state.selectedPersonType}
                                        onChange={this.handlePersonTypeChange}
                                        options={this.state.personTypeOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_tipo_persona')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.correo')}</label>
                                    <Select
                                        value={this.state.selectedEmail}
                                        onChange={this.handleEmailChange}
                                        options={this.state.emailOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_correo')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.activo')}</label>
                                    <Select
                                        value={this.state.selectedActive}
                                        onChange={this.handleActiveChange}
                                        options={this.state.activeOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_activo')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.expedientes_cliente')}</label>
                                    <Select
                                        value={this.state.selectedHasClient}
                                        onChange={this.handleHasClientChange}
                                        options={this.state.hasClientOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_expedientes_cliente')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.expedientes_proveedor')}</label>
                                    <Select
                                        value={this.state.selectedHasProvider}
                                        onChange={this.handleHasProviderChange}
                                        options={this.state.hasProviderOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_expedientes_proveedor')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.expedientes_empleado')}</label>
                                    <Select
                                        value={this.state.selectedHasCustomer}
                                        onChange={this.handleHasCustomerChange}
                                        options={this.state.hasCustomerOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_expedientes_empleado')} </div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold"> Expedientes Propios</label>
                                    <Select
                                        value={this.state.selectedHasOwn}
                                        onChange={this.handleHasOwnChange}
                                        options={this.state.hasOwnOptions}
                                        placeholder={<div>Buscas por expedientes propios</div>}
                                        isClearable={true}
                                    />
                                </div>
                                
                            </div>
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">#{lang.get('messages.expedientes')}</label>
                                    <Select
                                        value={this.state.selectedTotalDossiers}
                                        onChange={this.handletotalDossiersChange}
                                        options={this.state.totalDossiersOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_expedientes')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">País</label>
                                    <Select
                                        value={this.state.selectedCountryId}
                                        onChange={this.handleCountryIdChange}
                                        options={this.state.countryIdOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_pais')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">C.P.</label>
                                    <Select
                                        value={this.state.selectedZipCode}
                                        onChange={this.handleZipCodeChange}
                                        options={this.state.zipCodeOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por')} C.P.</div>}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-4 default">

                            <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">Municipio</label>
                                    <Select
                                        value={this.state.selectedMunicipio}
                                        onChange={this.handleMunicipioChange}
                                        options={this.state.municipioOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_municipio')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="datepicker-container">
                                        <label className="mb-0 text-dark-50 font-weight-bold">Fecha de creación</label><br></br>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                className="form-control d-flex align-items-center justify-content-between"
                                                style={{ cursor: 'pointer' }}
                                                onClick={this.toggleCreatedPicker}
                                            >
                                                <span>{this.state.startDate ? moment(this.state.startDate).format('ll') : lang.get('messages.fecha_inicio')}</span>
                                                <span className="mx-2">–</span>
                                                <span>{this.state.endDate ? moment(this.state.endDate).format('ll') : lang.get('messages.fecha_fin')}</span>
                                                {(this.state.startDate || this.state.endDate) && (
                                                    <span onClick={(e) => { e.stopPropagation(); this.clearDates(); }} style={{ marginLeft: 'auto' }}>
                                                        <i className="flaticon2-delete text-muted"></i>
                                                    </span>
                                                )}
                                            </div>

                                            {this.state.showCreatedPicker && (
                                                <div ref={this.createdPickerRef} className="date-range-popover">
                                                    <DateRange
                                                        ranges={[{
                                                            startDate: this.state.startDate ? new Date(this.state.startDate) : new Date(),
                                                            endDate: this.state.endDate ? new Date(this.state.endDate) : new Date(),
                                                            key: 'selection'
                                                        }]}
                                                        onChange={this.handleDateChange}
                                                        editableDateInputs={true}
                                                        moveRangeOnFirstSelection={false}
                                                        months={1}
                                                        direction="horizontal"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {this.state.showAdvancedFilters == false &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-down mr-2"></span> {lang.get('messages.mostrar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                    {this.state.showAdvancedFilters == true &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-up mr-2"></span> {lang.get('messages.ocultar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                </div>
                <div className="table-responsive">
                    <table className="table table-report w-100" id="datatable">
                        <thead>
                            <tr>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('tipo_expediente')}>
                                    {lang.get('messages.tipo_de_expediente')}
                                    {this.state.params.sort.column === 'tipo_expediente' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '90px' }} onClick={() => this.handleSort('id')}>
                                    ID
                                    {this.state.params.sort.column === 'id' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('name')}>
                                    {lang.get('messages.nombre')}
                                    {this.state.params.sort.column === 'name' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>

                                <th style={{ width: '200px' }} onClick={() => this.handleSort('fiscal_name')}>
                                    {lang.get('messages.razon_social')}
                                    {this.state.params.sort.column === 'fiscal_name' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('rfc')}>
                                    RFC
                                    {this.state.params.sort.column === 'rfc' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('person_type')}>
                                    {lang.get('messages.tipo_persona')}
                                    {this.state.params.sort.column === 'person_type' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '180px' }} onClick={() => this.handleSort('email')}>
                                    {lang.get('messages.correo')}
                                    {this.state.params.sort.column === 'email' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('active')}>
                                    {lang.get('messages.activo')}
                                    {this.state.params.sort.column === 'active' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('HasClient')}>
                                    {lang.get('messages.expedientes')} : {lang.get('messages.cliente')}
                                    {this.state.params.sort.column === 'HasClient' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('HasProvider')}>
                                    {lang.get('messages.expedientes')} : {lang.get('messages.proveedor')}
                                    {this.state.params.sort.column === 'HasProvider' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('HasCustomer')}>
                                    {lang.get('messages.expedientes')}: {lang.get('messages.empleado')}
                                    {this.state.params.sort.column === 'HasCustomer' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('HasOwn')}>
                                    {lang.get('messages.expedientes')}: Propios
                                    {this.state.params.sort.column === 'HasOwn' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('total_dossiers')}>
                                    #{lang.get('messages.expedientes')}
                                    {this.state.params.sort.column === 'total_dossiers' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('country_id')}>
                                    {lang.get('messages.pais')}
                                    {this.state.params.sort.column === 'country_id' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('zipcode')}>
                                    C.P.
                                    {this.state.params.sort.column === 'zipcode' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('municipio')}>
                                    {lang.get('messages.municipio')}
                                    {this.state.params.sort.column === 'municipio' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{width: '150px'}} onClick={() => this.handleSort('created_at')}>
                                    {lang.get('messages.fecha_invitacion')}
                                    {this.state.params.sort.column === 'created_at' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.providers.map((provider) => (
                                <tr key={provider.id} id={provider.id}>
                                    <td className="text-dark-50 font-weight-bold">{lang.get('messages.'+provider.tipo_expediente.toLowerCase())}</td>
                                    <td className="text-dark-75 font-weight-bolder">{`P-${provider.id}`}</td>
                                    <td className="text-dark-50 font-weight-bold">{provider.name}</td>
                                    <td className="text-dark-75 font-weight-bolder">{provider.fiscal_name}</td>
                                    <td className="text-dark-50 font-weight-bold">{provider.rfc}</td>
                                    <td className="text-dark-75 font-weight-bolder">{provider.person_type}</td>
                                    <td className="text-dark-50 font-weight-bold">{provider.email}</td>
                                    <td className="text-dark-75 font-weight-bolder">{provider.active == 1 ? 'Si' : 'No'}</td>
                                    <td className="text-dark-50 font-weight-bold">{provider.HasClient}</td>
                                    <td className="text-dark-75 font-weight-bold">{provider.HasProvider}</td>
                                    <td className="text-dark-50 font-weight-bold">{provider.HasCustomer}</td>
                                    <td className="text-dark-50 font-weight-bold">{provider.HasOwn}</td>
                                    <td className="text-dark-75 font-weight-bolder">{provider.total_dossiers}</td>
                                    <td className="text-dark-50 font-weight-bold">{provider.country_name}</td>
                                    <td className="text-dark-75 font-weight-bolder">{provider.zipcode}</td>
                                    <td className="text-dark-50 font-weight-bold">{provider.custom_municipality || provider.municipio_colombia || provider.municipio}</td>
                                    <td className="text-dark-75 font-weight-bolder my-1 mr-5"
                                        data-sort={provider.created_at === '' ? '' : new Date(provider.created_at).toISOString().slice(0,10)}>
                                        {provider.created_at === '' ? '' : new Date(provider.created_at).toLocaleDateString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between">
                        <div className="col mt-2 px-0">
                            {lang.get('messages.mostrando_del')} {this.state.showFrom} {lang.get('messages.al')} {this.state.showTo} {lang.get('messages.de')} {this.state.totalProviders} {lang.get('messages.registros')}.
                        </div>
                        <div className="row">
                            <div className="d-flex justify-content-between">
                                <p className="mr-2 mt-2">
                                    {lang.get('messages.mostrar')}:
                                </p>
                                <select
                                    value={this.state.itemsPerPage}
                                    onChange={this.handleItemsPerPageChange}
                                    aria-controls="datatable"
                                    className="custom-select custom-select-sm form-control form-control-sm"
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>
                            <ReactPaginate
                                previousLabel={'< ' + lang.get('messages.anterior')}  
                                nextLabel={ lang.get('messages.siguiente') + ' >'} 
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                activeClassName={'active'}
                                previousClassName={'previous'}
                                nextClassName={'next'}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
      );
    }
}

export default ReportsProviders;
